module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', [_vm._v("Contents")]), _c('ol', [_c('li', {
    attrs: {
      "id": "level1-titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-toc"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/toc"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front01"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front02"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c001"
    }
  }, [_vm._v("Cezary Strzybisz, Necrobes")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c002"
    }
  }, [_vm._v("Reginald Gulliver, Eruntics")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Juan Rambellais et. al., A History of Bitic Literature, Volume I")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "c03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to the Second Edition")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vestrand’s Extelopedia in 44 Magnetomes")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "c05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proffertinc")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sample Pages")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOLEM XIV")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "c07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Instructions")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Golem’s Inaugural Lecture—About Man Threefold")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lecture XLIII—About Itself")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-footnotes"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/footnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Footnotes")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0